import { Select, Option } from '@cian/ui-kit/prev';
import { useFormikContext, Field } from 'formik';
import * as React from 'react';

import { IFormValues } from '../../DealRentModal';
import * as styles from '../../index.css';
import { Label } from '../Label';
import { useFieldHasErrors } from '../utils';

export interface IChildrenInfoItemProps {
  index: number;
  options: string[];
}

export const ChildrenInfoItem = ({ index, options }: IChildrenInfoItemProps) => {
  const { setFieldValue } = useFormikContext<IFormValues>();
  const name = `childrenInfo[${index}]`;
  const invalid = useFieldHasErrors(name as 'childrenInfo');
  const onChange = React.useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>, value: string) => setFieldValue(name, value),
    [setFieldValue, name],
  );

  return (
    <div key={name} className={styles['field']}>
      <Label invalid={invalid}>{`Ребенок ${index + 1}`}</Label>
      <Field placeholder="Возраст" as={Select} onChange={onChange} name={name} custom={{ invalid }}>
        {options.map(value => (
          <Option key={value} value={value}>
            {value}
          </Option>
        ))}
      </Field>
    </div>
  );
};
